import { TenantBooleanSettingsFields } from "@sp-crm/core";
import { Toggle } from "components/ui/toggle";
import React from "react";
import { useTenantSettings } from "store/selectors/settings";

interface AgencyTogglePrefProps {
    description?: string;
    field: TenantBooleanSettingsFields;
    label: string;
    disabled?: boolean;
}

export const AgencyTogglePref: React.FC<AgencyTogglePrefProps> = props => {
    const { description, field, label, disabled } = props;
    const { settings, putSetting } = useTenantSettings();
    const onChangeCallback = React.useCallback(
        (isChecked: boolean) => {
            putSetting(field, isChecked);
        },
        [field, putSetting],
    );
    return (
        <div className="group">
            <Toggle
                checked={settings[field] as boolean}
                onChange={onChangeCallback}
                label={
                    <div>
                        <span className="text-md">{label}</span>
                        {description ? (
                            <div className="text-gray-500 group-hover:text-gray-900 text-sm">
                                {description}
                            </div>
                        ) : null}
                    </div>
                }
                disabled={disabled}
            />
        </div>
    );
};
